import { useForm as createUseForm } from "@ant-design-vue/use";
import lodash from "lodash";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { addModal } from "../../../app.logic";
import i18n from "../../../i18n";
import { modalStyleForm } from "../../../utils/constant";
import { initUseForm } from "../../../utils/form";
import { createLoading } from "../../../utils/loading";
import { validateError } from "../../../utils/validate";
import { dateFormat } from "../../../utils/date";

export const { isLoading, setIsLoading } = createLoading();

export const ModalCheckRegister = defineAsyncComponent(() => import("./ModalCheckRegister"));

export const openModalForm = ({ props, onOk, bind }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                title: i18n.global.t("views.register.modalCheckRegister.title"),
                width: "800px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <ModalCheckRegister
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></ModalCheckRegister>
        )
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
    };
};

export const createRules = () => {
    return {
    };
};

export const createField = ({ props }) => {
    return ["1"].includes(props.dataProp?.form?.refPersonType?.key) ? 
    [ ...createFieldFisherman1({ props }) ] : 
    [ ...createFieldFisherman2({ props }) ]
};

export const createFieldFisherman1 = ({ props }) => {
    const { dataProp } = props;
    return [
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("views.register.idTax") } { dataProp.form?.idCard }</div>
        },
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ dataProp.form?.companyNameTh }</div>
        },
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("model.user.email") } { dataProp.form?.email }</div>
        },
    ];
};

export const createFieldFisherman2 = ({ props }) => {
    const { dataProp } = props;
    return [
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("model.user.idCard") } { dataProp.form?.idCard }</div>
        },
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ dataProp.form?.refTitle?.value } { dataProp.form?.firstNameTh } { dataProp.form?.lastNameTh }</div>
        },
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("model.user.refNationality") } { dataProp.form?.refNationality?.value } { i18n.global.t("model.user.refRace") } { dataProp.form?.refRace?.value }</div>
        },
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("model.user.birthDate") } { dateFormat({ text: dataProp.form?.birthDate, format: "DD/MM/YYYY" }) }</div>
        },
        {
            visible: () => dataProp.form?.positionCode != null,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("model.user.positionCode") } { dataProp.form?.positionCode } { i18n.global.t("views.register.refDepartment") } { dataProp.form?.refDepartment?.nameTh }</div>
        },
        {
            visible: () => dataProp.form?.refSubDepartment != null,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("views.register.refSubDepartment") } { dataProp.form?.refSubDepartment?.nameTh }</div>
        },
        {
            visible: () => dataProp.form.email,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("model.user.email") } { dataProp.form?.email }</div>
        },
        {
            visible: () => dataProp.form?.mobile != null,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("model.user.mobile") } { dataProp.form?.mobile }</div>
        },
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
